module.exports = require("word-wrap");